"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cfeRecibidoConverter = void 0;
const cfeRecibidoConverter = {
    toFirestore(cfe) {
        return cfe;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        const cfeRecibido = {
            version: data.version,
            id: data.id,
            idSobreEmisor: data.idSobreEmisor,
            emisorNombre: data.emisorNombre,
            proveedorId: data.proveedorId,
            tipo: data.tipo,
            tipoId: data.tipoId,
            xml: data.xml,
            numero: data.numero,
            serie: data.serie,
            comprobante: data.comprobante,
            fechaFirma: data.fechaFirma,
            fechaComprobante: data.fechaComprobante,
            anulado: data.anulado,
            notificacionAnulado: data.notificacionAnulado,
            formaPago: data.formaPago,
            estadoInterno: data.estadoInterno,
            respuestaEstado: data.respuestaEstado,
            respuestaXML: data.respuestaXML,
            esRecibo: data.esRecibo,
            moneda: data.moneda,
            total: data.total,
            adenda: data.adenda,
            tcfe: data.tcfe
        };
        return cfeRecibido;
    }
};
exports.cfeRecibidoConverter = cfeRecibidoConverter;
